export enum ErrorMessage {
  FILE_NOT_SUPPORTED = 'File Type Not Supported',
  VALIDATION_SUMMARY_ERROR = 'You must supply the validation summary with an NgForm.',
  RECORD_SAVING_ERROR = 'Error Saving Records',
  RECORD_UPDATING_ERROR = 'Error Updating Records',
  RECORD_CREATING_ERROR = 'Error Creating Records',
  REQUEST_TYPE_REQUIRED = 'requestType is required',
  URL_REQUIRED = 'url is required',
  DUPLICATE_RECORD = 'Duplicate Record Found',
}
